<template>
  <div class="order-modal-step-two">
    <OrderInfoModal
      :value="mobile && showDetails"
      @input="v => (showDetails = null)"
    >
      <div v-if="showDetails === 'hotel'" class="order-modal-hotel">
        <div class="order-hotel-about">
          <h4>{{ $t("על המלון") }}</h4>
          <ul class="meta-highlights">
            <li v-for="(hl, i) in data.packageInfo.hotel.highlights" :key="i">
              <span class="icon"></span>
              <span>{{ hl.label }}</span>
            </li>
          </ul>
          <div
            class="order-hotel-description"
            v-html="ensureExternalLinks(data.packageInfo.hotel.description)"
          ></div>

          <div class="order-hotel-features hotel-features-list">
            <ul>
              <li
                v-for="(feature, i) in data.packageInfo.hotel.features"
                :key="i"
              >
                <span
                  class="icon"
                  :style="{ backgroundImage: 'url(' + feature.icon + ')' }"
                ></span>
                <span class="text">{{ feature.label }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <OrderFlightDetails
        v-else-if="showDetails === 'flight'"
        :airlineLogo="airlineLogo"
        :flights="data.package.flights"
      />
    </OrderInfoModal>

    <div class="order-modal-head">
      <div
        class="order-modal-title"
        :style="{
          backgroundImage: `url(${data.packageInfo.hotel.photo})`
        }"
      >
        <h3>
          <i class="icon icon-order-hotel"></i>
          <span v-html="data.packageInfo.hotel.title"></span>
          <small>
            {{
              moment(data.package.flights[0].date).format(
                data.package.flights[0].date.substr(5, 2) ==
                  data.package.flights[1].date.substr(5, 2)
                  ? "DD"
                  : "DD/MM/YYYY"
              )
            }}-{{ moment(data.package.flights[1].date).format("DD/MM/YYYY") }}
          </small>
        </h3>
      </div>

      <div
        class="order-modal-title-mobile"
        :style="{
          backgroundImage: `url(${
            selectedImage ? selectedImage.thumb : data.packageInfo.hotel.photo
          })`
        }"
      >
        <div class="order-modal-title-shadow"></div>
        <div class="order-modal-title-container">
          <div class="hotel-date">
            <span>
              {{
                moment(data.package.flights[0].date).format(
                  data.package.flights[0].date.substr(5, 2) ==
                    data.package.flights[1].date.substr(5, 2)
                    ? "DD"
                    : "DD/MM/YYYY"
                )
              }}-{{ moment(data.package.flights[1].date).format("DD/MM/YYYY") }}
            </span>
            <svg width="13" height="13" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" fill-rule="evenodd">
                <path
                  d="M1.14 11.111c0 .158.127.285.285.285h9.686a.285.285 0 00.285-.285V6.268H1.14v4.843zM1.14 3.134v1.994h10.256V3.134a.285.285 0 00-.285-.285H1.425a.285.285 0 00-.285.285z"
                />
                <path
                  d="M3.419 0a.57.57 0 00-.57.57v1.14H1.425C.638 1.71 0 2.346 0 3.133v7.977c0 .787.638 1.425 1.425 1.425h9.686c.787 0 1.425-.638 1.425-1.425V3.134c0-.787-.638-1.425-1.425-1.425H9.687V.57a.57.57 0 10-1.14 0v1.14H3.99V.57A.57.57 0 003.419 0zm7.977 11.111a.285.285 0 01-.285.285H1.425a.285.285 0 01-.285-.285V6.268h10.256v4.843zM9.116 2.85h1.995c.158 0 .285.128.285.285v1.994H1.14V3.134c0-.157.127-.285.285-.285h7.692z"
                  fill="#FFF"
                  fill-rule="nonzero"
                />
              </g>
            </svg>
          </div>
          <div class="hotel-name">
            {{ data.packageInfo.hotel.title }}
            <div class="hotel-rating">
              <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.631 9.146l3.64-3.658-4.975-.691L7.136 0l-2.16 4.797L0 5.488l3.641 3.658-.915 5.224 4.41-2.536 4.41 2.536z"
                  fill="#FFE000"
                  fill-rule="evenodd"
                />
              </svg>
              {{ data.packageInfo.hotel.rating }}
            </div>
          </div>
          <div class="hotel-bottom-line">
            <div class="hotel-location">
              {{ data.packageInfo.hotel.country }},
              {{ data.packageInfo.hotel.site }}
            </div>
            <div class="hotel-price">
              {{ data.packageInfo.hotel.price_from ? $t("מ-") : "" }}
              &euro;{{ data.packageInfo.hotel.price }}
              {{ $t("לאדם") }}
            </div>
          </div>
          <div class="order-modal-hotel-gallery-container">
            <div class="order-modal-hotel-gallery">
              <div
                :class="{
                  'order-modal-hotel-image': true,
                  active: selectedImage && selectedImage.thumb === image.thumb
                }"
                v-for="(image, i) in data.packageInfo.hotel.gallery"
                :key="i"
                :style="{ backgroundImage: 'url(' + image.thumb + ')' }"
                @click="selectedImage = image"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <OrderFlightDetails
        v-if="!mobile && showDetails === 'flight'"
        :airlineLogo="airlineLogo"
        :flights="data.package.flights"
      />
      <div v-if="!mobile && showDetails === 'hotel'" class="order-modal-hotel">
        <div class="order-hotel-head"></div>

        <div class="order-hotel-about">
          <h4>{{ $t("על המלון") }}</h4>
          <ul class="meta-highlights">
            <li v-for="(hl, i) in data.packageInfo.hotel.highlights" :key="i">
              <span class="icon"></span>
              <span>{{ hl.label }}</span>
            </li>
          </ul>
          <div
            class="order-hotel-description"
            v-html="ensureExternalLinks(data.packageInfo.hotel.description)"
          ></div>
        </div>

        <div class="order-hotel-features hotel-features-list">
          <ul>
            <li
              v-for="(feature, i) in data.packageInfo.hotel.features"
              :key="i"
            >
              <span
                class="icon"
                :style="{ backgroundImage: 'url(' + feature.icon + ')' }"
              ></span>
              <span class="text">{{ feature.label }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="order-modal-split">
      <div class="order-modal-package-contents">
        <PassengerAmounts
          v-if="mobile"
          :peopleByAge="peopleByAge"
          style="margin-bottom: 30px"
        />

        <div class="step-two-heading">
          <svg width="22" height="23" xmlns="http://www.w3.org/2000/svg">
            <g fill="#BDC0C7" fill-rule="nonzero">
              <path
                d="M11.05 0L1.03 5.44 11 10.88l9.98-5.44zM.05 16.98L10 22.41v-9.77L0 7.18zM12 12.64v9.82l10-5.48V7.19z"
              />
            </g>
          </svg>
          <div>
            <h4>{{ $t("מה כוללת חופשת הסקי שלכם?") }}</h4>
          </div>
        </div>

        <ul class="order-modal-package-contents-list">
          <li v-for="(line, i) in packageContents" :key="i">
            <svg width="12" height="9" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.939 4.31a.897.897 0 00-1.222.047.908.908 0 00-.047 1.229L3.37 8.3c.351.35.918.35 1.269 0l6.3-6.333a.908.908 0 00-.047-1.229A.897.897 0 009.67.691L4 6.391 1.939 4.31z"
                fill="#5ED9FF"
                fill-rule="nonzero"
              />
            </svg>
            <div v-html="ensureExternalLinks(line)"></div>
            <a v-if="i === 0" href="#" @click.prevent="toggleFlightDetails"
              >{{ showDetails === "flight" ? "-" : "+" }}
              {{ $t("פרטי הטיסה") }}
            </a>
            <a v-else-if="i === 3" href="#" @click.prevent="toggleHotelDetails">
              {{ showDetails === "hotel" ? "-" : "+" }}
              {{ $t("פרטי המלון") }}
            </a>
          </li>
        </ul>

        <div class="order-modal-comment">
          {{ siteData.orders.modal_comment }}
        </div>
      </div>
      <div class="order-modal-rooms">
        <PassengerAmounts v-if="!mobile" :peopleByAge="peopleByAge" />

        <div class="rooms-select">
          <div class="rooms-select-heading">
            <span>{{ $t("בחרו את סוג החדרים המתאים לכם") }}</span>
          </div>

          <table class="rooms-select-table">
            <thead>
              <tr>
                <th>{{ $t("סוגי חדרים") }}</th>
                <th v-html="$t('מחיר חבילה<br />לאדם בחדר')"></th>
                <th>{{ $t("מספר חדרים") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(offer, i) in roomOffers" :key="i">
                <td class="room-name">
                  <div class="room-name-primary">{{ offer.name }}</div>
                  <div class="room-name-secondary">{{ offer.description }}</div>
                  <div class="room-name-type">{{ offer.typeExtended }}</div>
                </td>
                <td class="room-price">&euro; {{ offer.price }}</td>
                <td class="room-count-control">
                  <CountControl
                    :value="roomCount(offer)"
                    :size="28"
                    @plus="addRoomCount(offer, 1)"
                    @minus="addRoomCount(offer, -1)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <ModalNextButton
      @next="onNext"
      @back="$emit('done', { event: 'back' })"
      :disabled="submitting || !canSubmit()"
    />
  </div>
</template>

<script>
import moment from "moment";
import ModalNextButton from "./ModalNextButton.vue";
import CountControl from "./CountControl.vue";
import PassengerAmounts from "./PassengerAmounts.vue";
import OrderInfoModal from "./OrderInfoModal.vue";
import OrderFlightDetails from "./OrderFlightDetails.vue";
import { $t } from "../../i18n";

export default {
  components: {
    ModalNextButton,
    CountControl,
    PassengerAmounts,
    OrderInfoModal,
    OrderFlightDetails
  },

  props: {
    value: {
      type: Object
    },
    data: {
      type: Object
    },
    packageData: {
      type: Object
    }
  },

  data() {
    return {
      form: this.value || {},
      submitting: false,
      showDetails: null,
      selectedImage: null,
      mobile: window.innerWidth < 992,
      siteData: window.siteData
    };
  },

  mounted() {
    window.addEventListener("resize", this.onResize);
  },

  beforeDestroy() {
    window.addEventListener("resize", this.onResize);
  },

  methods: {
    onResize() {
      this.mobile = window.innerWidth < 992;
    },

    onNext() {
      this.$emit("done", { event: "next" });
    },

    canSubmit() {
      return this.form.rooms.length > 0;
    },

    airlineLogo(flight) {
      return (window.siteData.airlineLogos || {})[
        flight.airline_number.substring(0, 2).toUpperCase()
      ];
    },

    peopleByAge(age) {
      let people = 0;

      for (const i in this.value.ageGroups) {
        const group = this.value.ageGroups[i];

        if (age == group.age) {
          people += group.wantedCount;
        }
      }

      return people;
    },

    roomCount(offer) {
      const rooms = this.form.rooms.filter(room => room.id === offer.id);

      return rooms.length;
    },

    addRoomCount(offer, value) {
      if (value > 0) {
        let passengers = [];

        const roomInfo = this.data.roomInfos.find(
          v => v.roomType === offer.type
        );

        for (
          let i = 0;
          i < Math.min(this.people, roomInfo ? roomInfo.maxPeople : 1);
          i++
        ) {
          passengers.push({
            firstName: "",
            lastName: "",
            type: "M",
            birthDate: null
          });
        }

        this.form.rooms.push({
          ...offer,
          passengers
        });

        return;
      }

      const roomIndex = this.form.rooms.findIndex(room => room.id === offer.id);
      if (roomIndex !== -1) {
        this.form.rooms.splice(roomIndex, 1);
      }
    },

    toggleFlightDetails() {
      this.showDetails = this.showDetails === "flight" ? null : "flight";
    },

    toggleHotelDetails() {
      this.showDetails = this.showDetails === "hotel" ? null : "hotel";
    },

    ensureExternalLinks(input) {
      let element = $("<div>" + input + "</div>");
      element.find("a").attr("target", "_blank");
      return element.html();
    }
  },

  computed: {
    roomClassInfo() {
      return this.data.packageInfo.hotel.classes;
    },

    moment: () => moment,

    roomOffers() {
      const offers = [];

      this.data.prices.forEach(price => {
        price.rooms.forEach(room => {
          const regularOffer = room.from_age == 0 && room.to_age == 0;
          if (!regularOffer) {
            return;
          }

          const roomInfo = this.data.roomInfos.find(
            v => v.roomType === room.type
          );

          if (
            roomInfo &&
            roomInfo.maxPeople &&
            this.people < roomInfo.maxPeople
          ) {
            return;
          }

          const roomType =
            this.roomClassInfo[price.class] &&
            this.roomClassInfo[price.class].room_types[room.type]
              ? this.roomClassInfo[price.class].room_types[room.type]
              : room.type;

          offers.push({
            id: price.class + "/" + room.type,
            // TODO: uncomment
            class: price.class,
            basis: price.basis,
            type: room.type,
            description:
              this.roomClassInfo && this.roomClassInfo[price.class]
                ? this.roomClassInfo[price.class].room_description
                : "",
            typeExtended: roomType,
            name:
              this.roomClassInfo && this.roomClassInfo[price.class]
                ? `${this.roomClassInfo[price.class].room_name}`
                : $t("חדר") + " " + price.class,
            price: this.siteData.customer.discount
              ? room.rate - this.siteData.customer.discount
              : room.rate
          });
        });
      });

      return offers.sort((offer, offer2) => offer.price - offer2.price);
    },

    packageContents() {
      let contents = this.data.packageInfo.hotel.contents;

      if (!Array.isArray(contents)) {
        contents = [];
      }

      // Fill until we have two lines.
      for (let i = 0; i < 2 - contents.length; i++) {
        contents.push("");
      }

      return contents;
    },

    people() {
      let people = 0;

      for (let i in this.value.ageGroups) {
        const group = this.value.ageGroups[i];

        if (group.age >= 12) {
          people += group.wantedCount || 0;
        }
      }

      return people;
    }
  },

  watch: {
    value() {
      this.form = JSON.parse(JSON.stringify(this.value));
    }
  }
};
</script>

<style lang="scss">
.order-modal-step-two {
  .order-modal-split {
    padding-top: 20px !important;
  }

  .order-modal-head {
    overflow: hidden;

    .order-modal-title {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: flex-end;
      padding: 26px 30px 20px 30px;
      height: 196px;
      position: relative;

      @media screen and (max-width: 991px) {
        display: none;
      }

      &::after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), transparent 55%)
          no-repeat;
        z-index: 0;
      }

      .icon {
        margin-left: 15px;
      }

      h3 {
        display: flex;
        align-items: center;
        color: #ffffff !important;
        font-size: 42px !important;
        font-weight: 900;
        line-height: 42px;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        margin: 0;
        z-index: 1;
      }

      small {
        font-size: 21px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        text-align: right;
        color: #ffffff;
        margin-right: 20px;
      }
    }

    .order-modal-title-mobile {
      display: none;
      color: #ffffff;
      letter-spacing: 0;
      text-align: left;
      position: relative;
      height: 60vh;
      align-items: flex-end;
      box-sizing: border-box;

      &::after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          180deg,
          rgba(36, 27, 53, 0) 0%,
          #ffffff 100%
        );
        z-index: 0;
      }

      .order-modal-title-shadow {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            0deg,
            rgba(0, 0, 0, 0),
            rgba(0, 0, 0, 0) 10%,
            rgba(25, 19, 53, 0.57) 35%,
            rgba(0, 0, 0, 0) 100%
          )
          no-repeat;
        z-index: 1;
      }

      .order-modal-title-container {
        z-index: 2;
        position: relative;
        width: 100%;
      }

      @media screen and (max-width: 991px) {
        display: flex;
      }

      .hotel-date {
        color: #ffffff;
        font-size: 15px;
        margin-bottom: 8px;
        padding: 0 20px;
      }

      .hotel-name {
        color: #ffffff;
        font-size: 21px;
        font-weight: bold;
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
        line-height: 1;
        margin-bottom: 8px;
        padding: 0 20px;

        .hotel-rating {
          display: flex;
          align-items: center;
          font-size: 17px;
          line-height: 18px;
          margin-left: 10px;

          svg {
            margin-right: 3px;
          }
        }
      }

      .hotel-bottom-line {
        display: flex;
        justify-content: space-between;
        flex-direction: row-reverse;
        padding: 0 20px;

        .hotel-location {
          font-size: 15px;
        }

        .hotel-price {
          color: #32c5ff;
          font-size: 20px;
          font-weight: 900;
        }
      }

      .order-modal-hotel-gallery-container {
        overflow-x: auto;
        overflow-y: visible;
        padding: 0 20px 40px 40px;

        .order-modal-hotel-gallery {
          display: flex;
          margin-top: 20px;
          box-sizing: border-box;
          float: right;

          .order-modal-hotel-image {
            width: 90px;
            height: 90px;
            flex-basis: 90px;
            min-width: 90px;
            border-radius: 10px;
            margin-left: 10px;
            opacity: 0.4;
            transform: opacity 0.2s ease;
            box-shadow: 0 24px 21px 0 rgba(0, 0, 0, 0.5);
            background-size: cover;
            background-position: center;
            transition: opacity 0.3s ease;

            &.active {
              opacity: 1;
            }
          }
        }
      }
    }
  }

  .step-two-heading {
    display: flex;
    align-items: center;

    svg {
      //
    }

    > div {
      margin-right: 10px;

      h4 {
        font-size: 19px;
        font-weight: 900;
        letter-spacing: 0;
        margin: 0;
      }
    }
  }

  .order-modal-package-contents {
    .order-modal-comment {
      position: relative;
      padding-right: 30px;
      font-weight: bold;
      margin-top: 25px;

      &::before {
        content: "";
        display: block;
        position: absolute;
        right: 0;
        top: 0;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 426.667 426.667'%3E%3Cpath d='M213.227 0C95.36 0 0 95.467 0 213.333s95.36 213.333 213.227 213.333 213.44-95.467 213.44-213.333S331.093 0 213.227 0zm.106 384c-94.293 0-170.667-76.373-170.667-170.667S119.04 42.667 213.333 42.667 384 119.04 384 213.333 307.627 384 213.333 384z'/%3E%3Cpath d='M192 277.333h42.667V320H192zM192 106.667h42.667v128H192z'/%3E%3C/svg%3E");
        width: 16px;
        height: 16px;
      }
    }

    .order-modal-package-contents-list {
      padding-top: 20px;

      @media screen and (max-width: 991px) {
        padding-top: 10px;
      }

      li {
        color: #2f3a4c;
        font-size: 16px;
        display: flex;
        align-items: flex-start;
        margin: 10px 0 !important;

        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(4),
        &:nth-child(5) {
          border-top: 1px solid rgba(151, 151, 151, 0.264);
          padding-top: 10px;
        }

        > svg {
          margin-top: 4px;
          margin-left: 10px;
          flex-shrink: 0;
        }

        > div {
          flex-grow: 1;

          p {
            margin: 0 !important;
          }
        }

        > a {
          white-space: nowrap;
          color: #02b6f4;
          font-size: 16px;
          font-weight: bold;
          padding-right: 6px;
        }
      }
    }
  }

  .order-modal-rooms {
  }

  .rooms-select {
    margin-top: 40px;
    letter-spacing: 0;

    .rooms-select-heading {
      font-size: 19px;
      font-weight: 900;
      letter-spacing: 0;
      background-color: #f8f8f8;
      padding: 10px 15px;
    }

    .rooms-select-table {
      margin-top: 20px;

      thead {
        th {
          padding: 0;
          font-size: 15px;
          padding-bottom: 8px;

          // &:nth-child(1) {
          //   width: 100%;
          // }

          &:nth-child(2),
          &:nth-child(3) {
            text-align: center;
          }
        }
      }

      tbody {
        td {
          padding: 20px 0;

          &:nth-child(2) {
            padding: 10px 15px;
          }

          &:nth-child(2),
          &:nth-child(3) {
            white-space: nowrap;
            text-align: center;
          }

          &.room-name {
            padding-left: 20px;

            .room-name-primary {
              font-size: 19px;
            }

            .room-name-secondary {
              color: #636363;
              font-size: 14px;
            }

            .room-name-type {
              color: #636363;
              font-size: 14px;
              font-weight: bold;
              color: #27b3ea;
            }
          }

          &.room-price {
            color: #27b3ea;
            font-size: 18px;
            direction: ltr;
          }

          &.room-count-control {
            .count-control {
              min-width: 90px;
            }
          }
        }
      }
    }
  }

  .order-modal-hotel {
    text-align: center;

    .order-hotel-head {
      //
    }

    .order-hotel-about {
      background: radial-gradient(circle, #dfe1e8 0%, #ebecf3 100%);
      padding: 35px 40px;

      h4 {
        color: #201a2d;
        font-size: 19px;
        font-weight: 900;
        margin: 0 0 15px 0;
      }

      .meta-highlights {
        justify-content: center;
        margin-bottom: 10px;

        li {
          flex-basis: auto;
          width: initial;
          min-width: initial;

          &:not(:last-child) {
            margin-left: 20px;
          }

          span {
            color: #000000;
            font-size: 16px;
          }
        }
      }

      .order-hotel-description {
        p:last-child {
          margin-bottom: 0;
        }
      }
    }

    .order-hotel-features {
      margin-top: 20px;

      ul {
        justify-content: center !important;

        li {
          flex-basis: auto !important;
          margin: 15px;
          border-radius: 2.6px;
          box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.1);
          background-color: #ffffff;
          padding-left: 15px;

          span.icon {
            background-color: transparent;
            box-shadow: none;
          }
        }
      }
    }
  }
}

.order-info-modal {
  .order-modal-hotel {
    padding: 65px 18px 18px 18px;

    h4 {
      color: #201a2d;
      font-size: 19px;
      font-weight: 900;
      text-align: center;
      margin-bottom: 30px;
    }

    ul.meta-highlights {
      display: block !important;
      text-align: center;
      position: relative;
      padding-bottom: 8px;
      margin-bottom: 20px;

      &::after {
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 60%;
        height: 1px;
        background-color: rgba(47, 58, 76, 0.1776);
      }

      li {
        display: inline-block !important;
        width: auto !important;
        margin: 0 7px 10px 7px;
        font-weight: 500;
        font-size: 16px;

        .icon {
          margin-left: 0;
        }
      }
    }

    .order-hotel-description {
      font-size: 16px;
      font-weight: 500;
      line-height: 1.2;
    }

    .hotel-features-list {
      margin-top: 30px;

      ul {
        justify-content: center;

        li {
          flex-basis: 47%;
          width: 47%;
        }
      }
    }
  }
}
</style>
